import { render, staticRenderFns } from "./TestingCenters.vue?vue&type=template&id=3fc92326&"
import script from "./TestingCenters.vue?vue&type=script&lang=ts&"
export * from "./TestingCenters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports